<template lang="pug">
  v-data-table.elevation-1(v-if='!read' :headers="headersVenta" :loading='loading' loading-text='Cargando productos...' :items="productosParaVenta" :search="search" :items-per-page='page' :page.sync='sync')
    template(v-slot:top)
      v-toolbar(flat dense color='primary' dark)
        v-toolbar-title Productos para la venta
        v-divider.mx-4(inset vertical)
        v-spacer
        v-text-field.text-xs-center(v-model='search' append-icon="search" label='Buscar Producto' single-line hide-details color='success')
        v-dialog(v-model='dialog' scrollable persistent max-width='60%')
          v-card(color='grey_1')
            v-app-bar(dark color='primary')
              v-toolbar-title.headline Cargar Producto
            v-divider(light)
            v-card-text
              v-row(dense)
                v-col(cols='12')
                  v-card(color='white')
                    v-card-text
                      v-row(v-if='($store.state.config.descuentoVenta && $store.state.config.descuentoVenta.valor) && ($store.state.config.pedido && $store.state.config.pedido.valor)')
                        v-row(dense)
                          v-col(cols='12' sm='12' md='6')
                            v-text-field( dense outlined readonly v-model="form.idProducto.nombre" label='Producto')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field( dense outlined readonly v-model="form.idProducto.descripcion" label='Descripción')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined type='number' min='0' v-model="cantSolicitada" label='Cantidad del Producto')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined v-model.number='porcDescuento' min='0' type='number' label='% Descuento')
                        v-row(dense class='d-flex justify-end')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined readonly :value="form.total" label='Total')
                      v-row(v-else)
                        v-row(dense)
                          v-col(cols='12' sm='12' md='6')
                            v-text-field( dense outlined readonly v-model="form.idProducto.nombre" label='Producto')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field( dense outlined readonly v-model="form.idProducto.descripcion" label='Descripción')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined type='number' min='0' v-model="cantSolicitada" label='Cantidad del Producto')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined readonly :value="form.total" label='Total')
                //v-col(cols='12' v-if='$store.state.config.pedido.valor')
                  v-card(color='white')
                    v-card-text
                      v-row(dense)
                        v-col(cols='6' sm='6' md='6')
                          v-autocomplete(autocomplete="off" dense outlined v-model='serialSelect' :items='serialesProducto' @keydown.native.enter='agregarSerial' auto-select-first :search-input.sync="search" label='Buscar Serial' persistent-hint hint='Busque un serial y presione ENTER para agregarlo' loader-height=5)
                            template(v-slot:no-data)
                              span No hay seriales para vender de este producto
                      v-row(dense)
                        v-col
                          v-data-table.elevation-1(:headers='headers' hide-default-footer :items='form.serialesSeleccionados')
                            template(v-slot:top)
                              v-toolbar(flat dense color='primary' dark)
                                v-toolbar-title Seriales
                            template(v-slot:item.action='{ item }')
                              v-tooltip(bottom)
                                template(v-slot:activator='{ on }')
                                  v-icon(color='error' @click='deleteSerial(item)' v-on="on") mdi-delete
                                | Eliminar
            v-card-actions
              v-spacer
              v-btn(color='error' small dark @click.native='dialog = false')
                v-icon mdi-close
                | Cancelar
              v-btn(color='success' small dark @click.native='cargarProducto')
                v-icon mdi-content-save
                | Cargar
    template(v-slot:item.action='{ item }')
      v-icon.mr-2(color='success' @click='editItem(item)') mdi-cart-plus
    template(v-slot:no-data)
      h2.pa-2 No hay productos para la venta
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'ProductosParaVenta',
  props: ['productosParaVenta', 'read', 'consignado', 'loading'],
  data: () => ({
    dialog: false,
    page: 5,
    sync: 1,
    porcDescuento: 0,
    editedIndex: -1,
    seriales: [],
    serialesProducto: [],
    serialSelect: '',
    search: null,
    /* headers: [
      { text: 'Número de Serial', value: 'text', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ], */
    headersVenta: [
      { text: 'Codigo', value: 'idProducto.nombre', align: 'center'},
      { text: 'Nombre', value: 'idProducto.descripcion', align: 'center'},
      //{ text: 'Stock', value: 'cantidad', filterable: false, sortable: false, align: 'center'},
      { text: 'Unidad de Venta', value: 'idProducto.unidadMedida.descripcion', filterable: false, sortable: false, align: 'center'},
      { text: 'Costo(Bs)', value: 'costo', filterable: false, align: 'center'},
      { text: 'IVA(%)', value: 'idIva.descripcion', filterable: false, sortable: false, align: 'center'},
      { text: 'Precio(Bs)', value: 'precioBs', filterable: false, align: 'center'},
      { text: 'Precio($)', value: 'precio', filterable: false, align: 'center'},
      { text: 'Accion', value: 'action', align: 'center', sortable: false }
    ],
    productos: [],
    cantSolicitada: 0,
    form: {
      porcDescuento: 0,
      idProducto: '',
      cantidadSolicitada: 0,
      unidadMedida: '',
      costo: 0,
      precioBs: 0,
      cantidad: 0,
      subTotal: 0,
      baseImponible: 0,
      idIva: '',
      gravado: 0,
      exento: 0,
      total: 0,
      serialesSeleccionados: []
    },
    defaultForm: {
      porcDescuento: 0,
      idProducto: '',
      cantidadSolicitada: 0,
      unidadMedida: '',
      costo: 0,
      precioBs: 0,
      cantidad: 0,
      subTotal: 0,
      baseImponible: 0,
      idIva: '',
      gravado: 0,
      exento: 0,
      total: 0,
      serialesSeleccionados: []
    }
  }),

  watch: {
    porcDescuento: function (val) {
      if (val >= 0) {
        this.form.porcDescuento = val
        this.form.subTotal = ((1 - val / 100) * this.form.precioBs) * this.cantSolicitada
        this.actualizarPrecios()
      } else {
        this.form.porcDescuento = 0
        this.form.subTotal = this.form.precioBs * this.cantSolicitada
        this.actualizarPrecios()
      }
    },
    cantSolicitada: function (val) {
      if (parseInt(val) > 0) {
        this.form.subTotal =
          Math.round(parseInt(val) * this.form.precioBs * 100) / 100
        this.actualizarPrecios()
      }
    },
    consignado (val) {
      if (val) {
        this.headersVenta.splice(2, 0, {
          text: 'Stock',
          value: 'cantidad',
          filterable: false
        })
      } else {
        this.headersVenta.splice(2, 1)
      }
    }
  },

  created () {
    /* if (!this.$store.state.config.pedido.valor) this.headersVenta.splice(2, 1)
    this.listarSerialesNoVendidos() */
  },

  methods: {
    agregarSerial (e) {
      // metodo que agrega el serial seleccionado al listado
      const serial = this.serialesProducto.find(serial => serial.value === this.serialSelect)
      if (serial) {
        this.form.serialesSeleccionados.push(serial)
        this.search = null
        this.serialSelect = null
        const index = this.serialesProducto.indexOf(serial)
        this.serialesProducto.splice(index, 1)
        // para que se pueda actualizar la tabla:
        this.form.serialesSeleccionados = [...this.form.serialesSeleccionados]
      }
    },

    deleteSerial (item) {
      // quita el serial de la tabla y lo pasa para poder seleccionar
      const index = this.serialesSeleccionados.indexOf(item)
      this.form.serialesSeleccionados.splice(index, 1)
      this.serialesProducto.push(item)
    },

    /* listarSerialesNoVendidos () {
      Api.get('/serial/venta/noVendidos')
        .then(res => {
          res.data.forEach(serial =>
            this.seriales.push({
              value: serial._id,
              text: serial.numeroSerial,
              idProducto: serial.idProducto
            }))
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    }, */

    actualizarPrecios () {
      this.form.total = 0
      if (this.form.idIva.valor > 0) {
        // Producto con IVA
        this.form.gravado =
          Math.round(this.form.subTotal * this.form.idIva.valor * 100) / 100
        this.form.exento = 0
        this.form.total =
          Math.round((this.form.gravado + this.form.subTotal) * 100) / 100

        this.form.baseImponible = this.form.subTotal
      } else {
        // Producto sin IVA
        this.form.gravado = 0
        this.form.baseImponible = 0
        this.form.exento = this.form.subTotal
        this.form.total = this.form.exento
      }
    },

    editItem (item) {
      this.editedIndex = this.productosParaVenta.indexOf(item)
      this.form = Object.assign({}, item)
      if (!this.form.serialesSeleccionados) this.form.serialesSeleccionados = []
      this.form.porcDescuento = 0
      this.form.total = 0
      this.cantSolicitada = 0
      this.serialesProducto = this.seriales.filter(serial => serial.idProducto._id === this.form.idProducto._id)
      this.dialog = true
    },

    cargarProducto () {
      this.form.cantidadSolicitada = parseInt(this.cantSolicitada)
      if (this.consignado) {
        // validacion si es consignado
        if (this.form.cantidadSolicitada > this.form.cantidad) {
          this.$swal({
            icon: 'error',
            title: 'La cantidad solicitada es mayor al stock',
            text: `cantidad solicitada: ${this.form.cantidadSolicitada}, cantidad en stock: ${this.form.cantidad}`
          })
        } else {
          this.form.cantidad -= this.form.cantidadSolicitada
          this.$emit('agregarAlCarrito', this.form)
          this.close()
        }
      } else {
        // validacion si no es consignado
        if (
          this.form.cantidadSolicitada <= 0 ||
          isNaN(this.form.cantidadSolicitada)
        ) {
          this.$swal({
            icon: 'error',
            title: 'La cantidad es Incorrecta'
          })
        } else {
          this.$emit('agregarAlCarrito', this.form)
          this.close()
        }
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
        this.editedIndex = -1
        this.cantSolicitada = 0
      }, 300)
    }
  }
}
</script>
